<template>
  <div style="height:100vh;width:100vw;background-color:black;">
    <QrcodeStream style="height:100vh;width:100vw;" :track="false" @decode="onDecode"></QrcodeStream>
    <v-dialog/>
  </div>
</template>

<script>

import Vue from 'vue';
import delay from 'delay';
import { QrcodeStream } from 'vue-qrcode-reader'
import VModal from 'vue-js-modal'
Vue.use(VModal, {dialog: true});

export default {
  name: 'hello',
  data () {
    return {
      prompt: false,
      message: ''
    }
  },
  methods: {
    onDecode(decodedString) {
      this.$modal.show('dialog', {
        title: 'QR Code Detected!',
        text: decodedString,
        buttons: [
          {
            title: '',       // Button title
            default: true,    // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: 'Close'
          }
        ]
      })
    },
  },
  components: {
    QrcodeStream,
    VModal
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Aligner {
  display: flex;
  align-items: center;
  justify-content: center;
  height:100vh;
  width:100vw;
}

.Aligner-item {
  max-width: 100%;
}

.Aligner-item--top {
  align-self: flex-start;
}

.Aligner-item--bottom {
  align-self: flex-end;
}

input, input:focus{
  padding-left:5px;
    outline: none;
    border: none;
    font-size: 15px;
}

video, .qrcode-stream, canvas {
    height:100% !important;
    width:100%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue